module.exports = __webpack_public_path__ + "img/profiling-michelin-star-chef-lisa-goodwin-allen.850a7904.jpg";